export default {
  "public_graphql_api_url": "https://bda6lpc25zhgvkd5tyke3updwy.appsync-api.us-east-1.amazonaws.com/graphql",
  "public_graphql_api_region": "appsync-api",
  "public_graphql_api_api_key": "da2-jkujw66ahzavxkmmkt6wnfbd7y"
}